<script>
 import { fade } from "svelte/transition";

	export let sections;
 export let index;
 export let progress;

 $: hide = index === (sections.length - 1) && progress > 1
</script>

{#if !hide}
 <div class="Pagination" transition:fade>
  {#each sections as { id }, i (id)}
   <a href={`#${id}`}>
    <div class={`Pagination__item ${index === i ? 'active' : ''}`} />
   </a>
  {/each}
 </div>
{/if}

<style lang="scss">
 .Pagination {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 30px;
  display: flex;
  flex-direction: column;
  z-index: 10;
  gap: 10px;
  flex-wrap: nowrap;

  @media (max-width: #{$breakpoint-mobile}) {
   display: none;
  }

  &__item {
   content: "";
   border-radius: 50px;
   border: 1px solid #fff;
   background-color: transparent;
   height: 12px;
   width: 12px;
   transition: background-color 400ms ease-in-out;
   cursor: pointer;

   @media (max-width: #{$breakpoint-mobile}) {
    height: 10px;
    width: 10px;
   }

   &.active {
    background-color: #fff;
   }

   &:hover {
    background-color: #fff;
   }
  }
 }
</style>
